module.exports = __webpack_public_path__ + "assets/img/landings_menu_burger_black.svg";